/**
 * URL.parse polyfill for environments that don't support it
 *
 * URL.parse 是 Node.js v19.0.0 之后引入的新方法，在 Electron webview 中可能不可用。
 * 这个 polyfill 通过使用现有的 URL 构造函数来模拟 URL.parse 的行为。
 *
 * 主要用于解决 pdfjs-dist 在 Electron webview 中的兼容性问题。
 */

interface UrlParseResult {
  href: string;
  origin: string;
  protocol: string;
  username: string;
  password: string;
  host: string;
  hostname: string;
  port: string;
  pathname: string;
  search: string;
  searchParams: URLSearchParams;
  hash: string;
}

if (typeof URL !== 'undefined' && typeof (URL as any).parse !== 'function') {
  (URL as any).parse = function (
    input: string,
    base?: string,
  ): UrlParseResult | null {
    try {
      const url = new URL(input, base);

      return {
        href: url.href,
        origin: url.origin,
        protocol: url.protocol,
        username: url.username,
        password: url.password,
        host: url.host,
        hostname: url.hostname,
        port: url.port,
        pathname: url.pathname,
        search: url.search,
        searchParams: url.searchParams,
        hash: url.hash,
      };
    } catch (error) {
      console.warn('[URL Polyfill] URL 解析失败:', input, error);
      return null;
    }
  };
}

export {};
